module.exports = {"TXTCLI_Amount":{"id":"TXTCLI_Amount","defaultMessage":"Montant","track":"Amount"}}